import React,{useEffect,useState} from 'react'
import TextField from '../../components/TextField'
import SubmitButton from '../../components/SubmitButton'
import {Error, Success} from '../../components/Status'
import {useUpdateRole} from '../../hooks/roles/useUpdate'
import {useGetPrivileges} from '../../hooks/users/useGet'

import Select from '../../components/Select'

const UpdateRole = ({role}) => {
    // STATES
    // PAYLOAD STATE
    const [state,setState]=useState({
        roleId:role.roleId,
        roleName:role.roleName,
        privilegeId:role?.privilege?.privilegeId,
        status:role.status
    })
    // MISC STATE
    const [error,setError]=useState("")
    const [success,setSuccess]=useState("")

    // MISC DATA
    const {data:privileges,isSuccess:gotPrivileges}=useGetPrivileges()
    const selectOptions=privileges?.map(item=>({name:`${item.privilegeName} (${item.description})`,value:item.privilegeId}))

    // MUTATION
    const {mutate:updateRole,error:updateError,isLoading,isSuccess}=useUpdateRole(role.roleId,state)
    
    // HANDLERS
    // INPUT HANDLER
    const handleChange=({target:{name,value}})=>{
            setState({...state,[name]:value})
    }


    const handleCheck=()=>{
        setState({...state,status:!state.status})
    }


    // SUBMIT HANDLER
    const handleSubmit=(e)=>{
        e.preventDefault();
        // REFRESH ERROR
        setError('')
        updateRole()
    }

    // EFFECTS
    useEffect(()=>{
        if(isSuccess){
            setSuccess("Role updated successfully")
            setTimeout(() => {
                window.location.reload()
            }, 2000);
        }
    },[isSuccess])

    useEffect(()=>{
        if(updateError){
            const message=updateError?.response?.data?.message
            setError(message)
        }
    },[updateError])

    return (
        <form className='w-full flex flex-col space-y-5' onSubmit={handleSubmit}>
            {success.length>0&&<Success>{success}</Success>}
            {error.length>0&&<Error>{error}</Error>}
            <TextField label='Role Name' required name='roleName' value={state.roleName} onChange={handleChange} />
            {gotPrivileges&&<Select name='privilegeId' onChange={handleChange} defaultValue={state.privilegeId} placeholder="Select an option" label='Privilege' options={selectOptions} required/>}
            {!role.status&& <TextField type='checkbox' label='Activate' name='activeStatus' checked={state.status} onChange={handleCheck} />}
            <SubmitButton loading={isLoading}>Submit</SubmitButton>
        </form>
    )
}
export default UpdateRole
